import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
const _excluded = ["width", "height"],
  _excluded2 = ["fit", "width", "height"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { i as g } from "./checks-C6AyTTQ0.js";
const M = /^image-([a-f\d]+)-(\d+x\d+)-(\w+)$/,
  w = {
    auto: "format",
    fit: "max",
    quality: 75
  },
  b = t => !!(t != null && t.asset) && (g(t.asset._id) || g(t.asset._ref)),
  R = function (t) {
    let r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "crop";
    const {
        dimensions: i
      } = l(t.asset._id),
      o = Math.round(i.width / i.height);
    let h = o,
      n = i.width,
      e = i.height;
    if (r != "clip" && "crop" in t && t.crop && Object.values(t.crop).some(s => s && s > 0)) {
      const s = Math.round(i.width - (t.crop.left || 0) * i.width - (t.crop.right || 0) * i.width),
        d = Math.round(i.height - (t.crop.top || 0) * i.height - (t.crop.bottom || 0) * i.height);
      h = Math.round(s / d), h > o ? e = d : n = s;
    }
    return {
      width: n,
      height: e
    };
  },
  l = t => {
    try {
      const [, r, i, o] = M.exec(t) || [],
        [h, n] = i.split("x").map(e => parseInt(e, 10));
      return {
        assetId: r,
        dimensions: {
          width: h,
          height: n
        },
        format: o
      };
    } catch (_unused) {
      throw new Error("Could not parse image ID \"".concat(t, "\""));
    }
  },
  I = t => {
    const {
      asset: r,
      hotspot: i,
      crop: o
    } = t;
    return r ? _objectSpread(_objectSpread({}, r), {}, {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      _id: r._id || r._ref,
      hotspot: i,
      crop: o
    }) : void 0;
  },
  S = t => {
    if (t) return typeof t != "string" && "localized" in t ? t.localized : t;
  },
  A = (t, r, _ref) => {
    let {
        width: i,
        height: o
      } = _ref,
      h = _objectWithoutProperties(_ref, _excluded);
    const {
        dimensions: n
      } = l(r._id),
      e = n.width / n.height;
    return i = i || n.width, o = o || Math.round(i / e), x(t, r, _objectSpread(_objectSpread({}, h), {}, {
      width: i,
      height: o
    }));
  },
  j = (t, r, i) => {
    const {
        dimensions: o
      } = l(r._id),
      h = i.fit || w.fit,
      n = o.width / o.height,
      e = i.width || o.width,
      s = i.height || Math.round(e / n),
      d = e / s;
    let u = n,
      p = o.width,
      m = o.height;
    if (h != "clip" && "crop" in r && r.crop && Object.values(r.crop).some(c => c && c > 0)) {
      const c = o.width - (r.crop.left || 0) * o.width - (r.crop.right || 0) * o.width,
        a = o.height - (r.crop.top || 0) * o.height - (r.crop.bottom || 0) * o.height;
      u = c / a, u > n ? m = a : p = c;
    }
    return Object.values([0.5, 1, 1.5, 2, 3].reduce((c, a) => {
      const _ = x(t, r, _objectSpread(_objectSpread({}, i), {}, {
          dpr: a
        })),
        f = Math.round(
        // For modes where Sanity will not scale up, determine
        // the anticipated final width based on the params
        ["fillmax", "max", "min"].includes(h) ? d < n ? Math.min(m / (s * a) * (e * a), e * a) : Math.min(e * a, p) : e * a);
      return c[f] || (c[f] = "".concat(_, " ").concat(f, "w")), c;
    }, {})).join(", ");
  },
  x = function (t, r) {
    let i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const {
        fit: o,
        width: h,
        height: n
      } = i,
      e = _objectWithoutProperties(i, _excluded2);
    let s = {
      fit: o,
      width: h,
      height: void 0
    };
    return o != "clip" && (s = _objectSpread(_objectSpread({}, s), {}, {
      height: n
    })), o == "clip" && (s = _objectSpread(_objectSpread({}, s), {}, {
      fit: "max"
    })), Object.entries(_objectSpread(_objectSpread(_objectSpread({}, w), s), e)).reduce((d, _ref2) => {
      let [u, p] = _ref2;
      return p ? Array.isArray(p) ? d[u](...p) : d[u](p) : d;
    }, t.image(r)).url().replace(/, /g, ",");
  };
export { x as a, A as b, R as c, j as d, S as g, b as i, l as p, I as t };